/**
 * İLİŞKİ DURUMU — "bilmiyorum"u "hayır"a çevirmeyi bitiren tek yardımcı.
 *
 * ── SORUN (EMİR #97 / A5) ────────────────────────────────────────────────
 * Beş serviste aynı desen vardı:
 *     onSnapshot(ref, (snap) => cb(snap.exists()), () => cb(false))
 *                                                   ^^^^^^^^^^^^^
 * Hata dalı "okuyamadım"ı "hayır" diye bildiriyordu. Bu, `snap.exists()`
 * vakasının ilişki eksenindeki hâli: KANITIN YOKLUĞU, YOKLUĞUN KANITI DEĞİL.
 *
 * SOMUT ZARAR (engelleme yüzeyinde, en ağırı): kullanıcı birini ENGELLEMİŞ
 * ama okuma başarısız olunca arayüz "Engelle" gösteriyor → ENGELİ KALDIRMA
 * SEÇENEĞİ EKRANDA HİÇ YOK → kullanıcı geri alamıyor. "Zaten engelliyi tekrar
 * engellemek zararsız" değil; kapanan şey GERİ ALMA YOLU.
 *
 * ── AYRIM: HANGİ `false` YALAN, HANGİSİ DOĞRU ────────────────────────────
 * Aynı fonksiyonlardaki İKİ `cb(false)` aynı şey DEĞİL:
 *   1. Muhafız dalı (`!me || !targetUid || me.uid === targetUid`) → GERÇEK
 *      cevap. Kendini engelleyemezsin; giriş yoksa ilişki de yok. `hayir`.
 *   2. Hata dalı (onSnapshot error) → CEVAP YOK. `bilinmiyor`.
 * Yalnız ikincisi düzeltilir; birincisini "bilinmiyor" yapmak ters yönde bir
 * yalan olurdu (aşırı-gate).
 *
 * ── TEK YARDIMCI ≠ TEK ARAYÜZ KARARI (mimar hükmü) ───────────────────────
 * Bu yardımcı SİNYALİ birleştirir. "bilinmiyor iken ekranda ne olur" YÜZEYE
 * göre değişir:
 *   · aç/kapa butonu (engelle, kısıtla) → devre dışı + "Yükleniyor"
 *   · rozet (sessize alındı)            → rozeti GÖSTERME ama yokluk İDDİA ETME
 *   · liste                             → yükleniyor durumu
 * Körlemesine hepsini `disabled` yapmak yanlış: rozette `disabled` diye bir
 * şey yok, oradaki doğru davranış SESSİZ KALMAK — ama sessizliği "hayır" diye
 * yorumlatmadan.
 *
 * ── MAHREMİYET ASİMETRİSİ (closeFriends) ─────────────────────────────────
 * "Bu kişi yakın arkadaşım mı" bilinmezken zararlar SİMETRİK DEĞİL:
 *   yanlış "değil"  → içerik görülmez            (geri alınabilir)
 *   yanlış "öyle"   → görülmemesi gereken görülür (GERİ ALINAMAZ)
 * Temkinli taraf bu yüzden bellidir: bilinmiyorken paylaşımı KOLAYLAŞTIRAN
 * tarafa düşülmez; açıklamaya düşülür ("liste yüklenemedi") ve seçim
 * kullanıcıya bırakılır.
 */

export type IliskiDurumu = "bilinmiyor" | "evet" | "hayir";

/** Eski (boolean) çağıranlar için: yalnız `evet` true'dur. */
export const durumBoolean = (d: IliskiDurumu): boolean => d === "evet";

/** Aç/kapa butonu bu durumda tıklanabilir mi? */
export const butonEtkinMi = (d: IliskiDurumu): boolean => d !== "bilinmiyor";

/**
 * Rozet gösterilsin mi? `bilinmiyor` → HAYIR, ama bu "yok" demek DEĞİL —
 * çağıran taraf yokluk iddiasında bulunmamalı (metin yazmamalı).
 */
export const rozetGosterilsinMi = (d: IliskiDurumu): boolean => d === "evet";

/**
 * `exists`/hata sinyalini üç değerli duruma çevirir.
 * @param hata true ise okuma başarısız oldu → `bilinmiyor`
 */
export function durumCoz(varMi: boolean, hata = false): IliskiDurumu {
  if (hata) return "bilinmiyor";
  return varMi ? "evet" : "hayir";
}
